








import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ErrorMessages extends Vue {
  @Prop(Object) errors: { [key: string]: string }
}
